export function repeatMultiplier(occurrence: number): number {
  if (occurrence <= 1) return 1;
  if (occurrence === 2) return 0.75;
  if (occurrence === 3) return 0.5;
  return 0.25;
}
